<div class="input-group" [ngClass]="{ 'input-group-sm': small_input }">
  <input
    [(ngModel)]="documentTypeSearchTerm"
    [appAutocomplete]="'/document_types/field_search'"
    [data]="{ typeahead: true }"
    [minLength]="2"
    [include_item]="include_item"
    (autocompleteSelect)="documentTypeSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for document type'"
    class="form-control"
    [disabled]="!select_only && (!!documentTypeId || !editable)"
    type="text"
    name="document_type_search"
    ngDefaultControl
  />
  <div class="input-group-append">
    <button type="button" class="btn btn-default btn-secondary" [disabled]="!documentTypeId || !editable" (click)="clearSelectedDocumentType()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
